import React from 'react';

const FooterMap = () => {
    return (
        <div className="map-container" style={{ width: '100%', height: '300px', borderTop: '1px solid #ccc' }}>
            <iframe
                title="Google Map"
                width="100%"
                height="100%"
                frameBorder="0"
                style={{ border: 0 }}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3925.90923994322!2d77.47120079999999!3d10.268896500000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b07670f3d3105ed%3A0x1c3640d160fbfb8a!2sElkar&#39;s%20home%20stay!5e0!3m2!1sen!2sin!4v1759822978963!5m2!1sen!2sin"
            ></iframe>
        </div>
    );
};

export default FooterMap;

